import template from './outstanding_data_report.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class OutstandingDataViewModel
{
	constructor (page)
	{
		this.page = page;

		this.employee_missing_data = ko.observableArray();

		this.show_export_table = ko.observable(false);
		this.include_default = ko.observable(true),
		this.show_correct_values = ko.observable(false),

		this.current_department_id = ko.observable();
		this.selected_department = ko.observable();

		this.selected_department.subscribe((newValue) => {
			if (newValue != null)
			{
				this.current_department_id(newValue.department_id);
				this.page.updateData();
			}
			else
			{
				this.current_department_id(null);
				this.page.updateData();
			}
		});

		this.include_default.subscribe((newText) => {
			this.page.updateData();
		});

		this.show_correct_values.subscribe((newText) => {
			this.page.updateData();
		});
	}

	back_to_top()
	{
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	}
}

class OutstandingDataPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new OutstandingDataViewModel(this);
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('OutstandingDataReport'))
			return;

		document.title = tr('Outstanding Employee Information');
		window.current_page_title(tr('Outstanding Employee Information'));
	}

	updateData()
	{
		this.updateReportData();
	}

	async updateReportData()
	{
		let data = {
			department_id: this.viewModel.current_department_id()
		};

		let res = await Grape.fetches.postJSON('/reports/outstanding_data_report', data);

		if (res)
			this.viewModel.employee_missing_data(ko.mapping.fromJS(res));
	}

	show_report_help()
	{
		Grape.dialog.open('OutstandingDataHelp', { 'employee_id': this.bindings.id }, {});
	}

	async downLoadClicked(v, e)
	{
		let csv_string = await Utils.table_to_csv(document.getElementById('outstanding_data_report'));

		if (csv_string === null || csv_string === undefined || csv_string === '')
			return;

		let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
		let link = document.createElement('a');

		link.href = URL.createObjectURL(blob);
		link.setAttribute('download', 'outstanding_data_report.csv');

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
}

export default {
	route: '[/]report/outstanding_data',
	page_class: OutstandingDataPage,
	template: template,
	template_filename: 'translation/outstanding_data_report'
};
